/**
 * Budgy has one guest flow (OTP `loginOrCreate`), not recruitment's
 * sign-in-vs-sign-up split, so every unauthenticated redirect lands here.
 */
export function getAuthRedirectTarget(): '/auth/sign-in' {
  return '/auth/sign-in';
}
